import React, { useState } from 'react';
import { signInUser, signInAdmin } from '../../api-helpers/api-helpers.js'; 

import { useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Alert from '@mui/material/Alert'; 

const theme = createTheme({
  palette: {
    mode: 'dark', 
    background: {
      default: "rgb(16, 20, 25)"
    },
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f48fb1',
    },
  },
});

export default function SignInSide() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [isAdmin, setIsAdmin] = useState(false); 
  



  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const credentials = {
        email: data.get('email'),
        password: data.get('password'),
    };

    try {
        const result = isAdmin ? await signInAdmin(credentials) : await signInUser(credentials);
        //console.log("Result from login:", result);

        if (result.success) {
            //console.log('Login successful', result.token);
            localStorage.setItem("isLoggedIn", "true");
            localStorage.setItem("token", result.token);
            localStorage.setItem("userId", result.userId);
           // console.log('Login successful', result.userId); 

            if (isAdmin) {
                localStorage.setItem("role", "admin");
                navigate('/Manage-event');
            } else {
                navigate('/events');
            }
        } else {
            setError(result.message || 'Invalid email or password.');
        }
    } catch (error) {
        console.error("Login error:", error);
        setError('Login failed due to an unexpected error.');
    }
};

  const handleAdminToggle = () => {
    setIsAdmin(!isAdmin);
  };
  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: 'url(https://source.unsplash.com/random?wallpapers)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in {isAdmin ? "Admin" : "User"}
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              {error && <Alert severity="error">{error}</Alert>} 
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Sign In
              </Button>
              <Grid container justifyContent="flex-end">
                <Grid item>
                  <Button onClick={handleAdminToggle} color="primary">
                    {isAdmin ? "Switch to User" : "Switch to Admin"}
                  </Button>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="/signup" variant="body2">
                    Don't have an account? Sign Up
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
